//import Vue from 'vue';
import request from '@/Utilities/httpRequest';

export default {
    
    async backendRequest(url, id = null, params = {}, data = { quicksearch: "1", no_action: "1"}, isMobile = false) { // may be separated soon
        //let data = { quicksearch: "1", no_action: "1"};
        // console.log(data);
        // console.log(quickSearchObj);
        // if(data && typeof quickSearchObj === 'object'){
        //     quickSearchObj.historyPush(data, null, url);
        // } else if(data && isMobile) {
        //     window.history.pushState(data, null, url);
        // }
        if(data && window.location.port !== '8080'){
            window.history.pushState(data, null, url);
        }
        return await request.get(url, params, false);
    },

    async loadStyleSheet(path, id) {
        if(!path){
            return;
        }
        let head = document.getElementsByTagName('head')[0], // reference to document.head for appending/ removing link nodes
            link = document.createElement('link');           // create the link node
        link.setAttribute('href', path);
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('id', id);// how long to wait before failing
        head.appendChild(link);  // insert the link node into the DOM and start loading the style sheet

        return link; // return the link node;
    },
    numberFiltersApplied(data){
        let counter = 0;
        if(data){
            for(let i=0; i< data.length; i++){
                counter++;
            }
        }
        return counter;
    }
};

